// src/layout/Layout.jsx
// 認証済みページ用の枠。Sidebar + Topbar + メインコンテンツ。
// 【2026-07-21】スマホ対応: サイドバーをドロワー化し、下部タブバーを追加。
//   - drawerOpen: スマホ幅でのドロワー開閉状態（デスクトップでは常時表示でこの状態は無視される）

import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import MobileTabBar from './MobileTabBar';
import AndroidAppBanner from '../components/AndroidAppBanner';

export default function Layout({ user, onLogout, children }) {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const closeDrawer = () => setDrawerOpen(false);

  return (
    <div className="app-shell">
      <Sidebar user={user} open={drawerOpen} onClose={closeDrawer} />
      {/* ドロワーの外側タップで閉じる背景（スマホのみ表示） */}
      {drawerOpen && <div className="drawer-backdrop" onClick={closeDrawer} />}
      <div className="app-main">
        <Topbar user={user} onLogout={onLogout} onMenuClick={() => setDrawerOpen(o => !o)} />
        <main className="main-content">
          <AndroidAppBanner />
          {children}
        </main>
      </div>
      <MobileTabBar user={user} onMenuClick={() => setDrawerOpen(true)} />
    </div>
  );
}
